import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Sparkles, ShoppingBag, User } from 'lucide-react';

const navItems = [
  { path: '/', label: 'Home', Icon: Home },
  { path: '/services', label: 'Services', Icon: Sparkles },
  { path: '/shop', label: 'Shop', Icon: ShoppingBag },
  { path: '/account', label: 'Account', Icon: User },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav data-testid="bottom-nav" className="fixed bottom-0 left-0 right-0 z-50 h-20 bg-white/80 backdrop-blur-xl border-t border-warm-border safe-area-bottom">
      <div className="max-w-md mx-auto flex items-center justify-around h-full px-4">
        {navItems.map(({ path, label, Icon }) => {
          const isActive = path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              data-testid={`nav-${label.toLowerCase()}`}
              className={`flex flex-col items-center gap-1 py-2 px-5 rounded-xl transition-colors ${
                isActive ? 'text-warmgold' : 'text-text-muted hover:text-espresso'
              }`}
            >
              <Icon size={22} strokeWidth={isActive ? 2.5 : 1.5} />
              <span className="text-[11px] font-semibold tracking-wide uppercase">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
